import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SequenceCoreService } from './sequence-core.service';
import { SequenceSelectorComponent } from './sequence-selector/sequence-selector.component';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';

@NgModule({
  declarations: [SequenceSelectorComponent],
  imports: [CommonModule, ReactiveFormsModule, SharedModule],
  providers: [SequenceCoreService],
  exports: [SequenceSelectorComponent],
})
export class SequenceCoreModule {}
